import { render } from "./_PageLayout.vue?vue&type=template&id=5abb6985"
import script from "./_PageLayout.vue?vue&type=script&lang=js"
export * from "./_PageLayout.vue?vue&type=script&lang=js"

import "./_PageLayout.vue?vue&type=style&index=0&id=5abb6985&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__